module.exports = __webpack_public_path__ + "ea09780caa4e21776d0b2229c1c6b5db.glb";